import { render, staticRenderFns } from "./Byk.vue?vue&type=template&id=4c7b6c77&scoped=true&"
import script from "./Byk.vue?vue&type=script&lang=js&"
export * from "./Byk.vue?vue&type=script&lang=js&"
import style0 from "./Byk.vue?vue&type=style&index=0&id=4c7b6c77&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4c7b6c77",
  null
  
)

export default component.exports